export default __webpack_public_path__ + "media/images/theme/bg_dark_backup-b9e27bbc51db1cb0b8d00ee7d91c2b02.png";